import { ModelBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class ReplyLookupData extends ModelBase {
    public id: string = ""
    public message: string = ""
    public subject: string = ""
    public responded_back_at?: string = ""
    public type: string = ""
}